import { AlertCircle } from "lucide-react";

interface DebugBadgeProps {
  isEditMode: boolean;
  companyId?: number | null;
  isMatriz?: boolean;
  matrizId?: number | null;
  controladoraId?: number | null;
}

/**
 * DebugBadge - Componente de debug visual
 * 
 * Exibe o estado atual da empresa para facilitar testes
 * Apenas renderizado em modo de desenvolvimento/teste
 * 
 * Regras:
 * - Discreto (cinza claro, pequeno)
 * - Mostra valores undefined explicitamente
 * - Não quebra se campos faltarem
 */
export default function DebugBadge({
  isEditMode,
  companyId,
  isMatriz,
  matrizId,
  controladoraId,
}: DebugBadgeProps) {
  // Renderizar apenas em modo de teste (rota /clientes-tabs)
  // Em produção, este componente não será usado
  const isDevelopment = typeof window !== "undefined" && window.location.pathname.includes("clientes-tabs");

  if (!isDevelopment) {
    return null;
  }

  const formatValue = (value: any): string => {
    if (value === undefined) return "undefined";
    if (value === null) return "null";
    if (value === true) return "true";
    if (value === false) return "false";
    return String(value);
  };

  return (
    <div className="mb-4 p-3 bg-gray-50 border border-gray-200 rounded-md">
      <div className="flex items-start gap-2">
        <AlertCircle className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
        <div className="text-xs text-gray-600 font-mono space-y-1">
          <div>
            <span className="font-semibold text-gray-700">isEditMode:</span>{" "}
            <span className={formatValue(isEditMode) === "true" ? "text-green-600" : "text-red-600"}>
              {formatValue(isEditMode)}
            </span>
          </div>
          <div>
            <span className="font-semibold text-gray-700">companyId:</span>{" "}
            <span className="text-gray-600">{formatValue(companyId)}</span>
          </div>
          <div>
            <span className="font-semibold text-gray-700">isMatriz:</span>{" "}
            <span className={formatValue(isMatriz) === "true" ? "text-green-600" : "text-gray-600"}>
              {formatValue(isMatriz)}
            </span>
          </div>
          <div>
            <span className="font-semibold text-gray-700">matrizId:</span>{" "}
            <span className="text-gray-600">{formatValue(matrizId)}</span>
          </div>
          <div>
            <span className="font-semibold text-gray-700">controladoraId:</span>{" "}
            <span className="text-gray-600">{formatValue(controladoraId)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
